







import { useEffect, useState } from "react";
import { getProjectsApi, deleteProjectApi, updateProjectApi, getallDemoProjectsApi } from "../../app/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  ChevronDownIcon,
  PencilSquareIcon,
  TrashIcon,
  GlobeAltIcon,
  ServerStackIcon,
  CpuChipIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import { createPortal } from "react-dom";

export default function ProjectsListPage() {
  const [projects, setProjects] = useState([]);
  const [demoProjects, setDemoProjects] = useState([]);
  const [showDemo, setShowDemo] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Auto-switch view based on ?view= query param from KPI card click
  useEffect(() => {
    const view = searchParams.get("view");
    if (view === "demo") {
      setShowDemo(true);
      fetchDemoProjects(); // always fetch fresh on navigation
    } else {
      setShowDemo(false); // covers 'simple' and default
    }
    // Scroll to list section
    setTimeout(() => {
      const el = document.getElementById("project-list-section");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 400);
  }, [searchParams]);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await getProjectsApi();
      if (res.success) {
        setProjects(res.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchDemoProjects = async () => {
    setLoading(true);
    try {
      const res = await getallDemoProjectsApi();
      if (res.success) {
        setDemoProjects(res.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteProjectApi(selectedProject.id);
      setShowDelete(false);
      fetchProjects();
      alert("✅ Project Deleted Successfully");
    } catch (err) {
      alert(err.message);
    }
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };


  const [filters, setFilters] = useState({
    client: "",
    country: "",
    service: "",
    created_by_name: ""
  });

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleResetFilters = () => {
    setFilters({
      client: "",
      country: "",
      service: "",
      created_by_name: ""
    });
  };

  const filteredProjects = projects.filter((p) => {
    return (
      p.client?.toLowerCase().includes(filters.client.toLowerCase()) &&
      p.country?.toLowerCase().includes(filters.country.toLowerCase()) &&
      p.created_by_name?.toLowerCase().includes(filters.created_by_name.toLowerCase()) &&

      // 🔥 Service filter (important)
      (filters.service === "" ||
        p.services?.some(s =>
          s.service?.toLowerCase().includes(filters.service.toLowerCase())
        ))
    );
  });

  return (
    <div className="min-h-screen px-6 py-8 md:mt-24  bg-gradient-to-br from-[#140c2b] via-[#1f1147] to-[#0f0825] text-white rounded-[20px]">
      {/* Header */}
      {/* <div className="flex justify-between items-center mb-10">
        <div>
          <h1 className="text-4xl font-extrabold bg-gradient-to-r from-purple-400 to-indigo-400 bg-clip-text text-transparent">
            All Projects
          </h1>
          <p className="text-white/50 mt-1">Central deployment console for all global projects.</p>
        </div>
        <button
          onClick={() => navigate("/projects/create")}
          className="px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-2xl font-bold shadow-lg hover:scale-105 active:scale-95 transition-all flex items-center gap-2"
        >
          <GlobeAltIcon className="w-5 h-5" /> Deploy New Project
        </button>
      </div> */}


      {/* HEADER */}
      {/* <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-semibold text-white">Projects</h1>
          <p className="text-white/60 text-sm">
            Manage all your created projects
          </p>
        </div>

        <button
          onClick={() => navigate("/projects/create")}
          className="px-5 py-2 bg-purple-600 text-white rounded-lg shadow hover:scale-[1.03]"
        >
          + Create Project
        </button>
      </div> */}


      <div className="flex md:flex-row flex-col md:justify-between  md:items-center mb-6">

        <div>
          <h1 className="text-3xl font-semibold text-white md:mt-0 mt-[-24px]">Projects</h1>
          <p className="text-white/60 text-sm">
            Manage all your created projects
          </p>
        </div>

        {/* RIGHT BUTTONS */}
        <div className="flex md:flex-row flex-col gap-3 ">

          {/* ✅ NEW BUTTON */}
          <button
            onClick={() => navigate("/apps/list")}
            className="px-5 py-2 bg-blue-600 text-white rounded-lg shadow hover:scale-[1.03]"
          >
            App Projects
          </button>

          <button
            onClick={() => {
              setShowDemo(!showDemo);
              if (!showDemo && demoProjects.length === 0) fetchDemoProjects();
            }}
            className={`px-5 py-2 whitespace-nowrap rounded-lg shadow hover:scale-[1.03] text-white ${showDemo ? 'bg-orange-600' : 'bg-orange-500'}`}
          >
            {showDemo ? "Show Regular Projects" : "Show Demo Projects"}
          </button>

          <button
            onClick={() => navigate("/projects/create")}
            className="px-5 py-2 bg-purple-600 text-white rounded-lg shadow hover:scale-[1.03] whitespace-nowrap"
          >
            + Create Project
          </button>

        </div>

      </div>









      <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-4 mb-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">

          <input
            type="text"
            placeholder="Search by Client"
            value={filters.client}
            onChange={(e) => handleFilterChange("client", e.target.value)}
            className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
          />

          <input
            type="text"
            placeholder="Search by Country"
            value={filters.country}
            onChange={(e) => handleFilterChange("country", e.target.value)}
            className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
          />

          <input
            type="text"
            placeholder="Search by Service"
            value={filters.service}
            onChange={(e) => handleFilterChange("service", e.target.value)}
            className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
          />

          <input
            type="text"
            placeholder="Search by Created By"
            value={filters.created_by_name}
            onChange={(e) => handleFilterChange("created_by_name", e.target.value)}
            className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
          />

          <button
            onClick={handleResetFilters}
            className="px-2 py-2 text-sm rounded-[10px]
      bg-gradient-to-r from-cyan-500 to-blue-500
      text-white shadow-lg hover:scale-105 transition-all duration-300"
          >
            Reset
          </button>

        </div>
      </div>

      {loading ? (
        <div className="flex flex-col items-center justify-center h-64 space-y-4">
          <div className="w-12 h-12 border-4 border-purple-500/20 border-t-purple-500 rounded-full animate-spin" />
          <p className="text-white/40">Synchronizing Project data...</p>
        </div>
      ) : (
      <div id="project-list-section" className="grid grid-cols-1 gap-6">
          {showDemo ? (
            demoProjects.length === 0 ? (
              <div className="text-center py-20 bg-white/5 rounded-3xl border border-white/10 border-dashed">
                <GlobeAltIcon className="w-12 h-12 text-white/10 mx-auto mb-4" />
                <p className="text-white/40 text-lg">No demo projects found.</p>
              </div>
            ) : (
              demoProjects.map((p) => (
                <DemoProjectCard key={p.id} project={p} />
              ))
            )
          ) : (
            projects.length === 0 ? (
              <div className="text-center py-20 bg-white/5 rounded-3xl border border-white/10 border-dashed">
                <GlobeAltIcon className="w-12 h-12 text-white/10 mx-auto mb-4" />
                <p className="text-white/40 text-lg">No global projects found.</p>
              </div>
            ) : (
              filteredProjects.map((p) => (
                <ProjectCard
                  key={p.id}
                  project={p}
                  isExpanded={expandedId === p.id}
                  onToggle={() => toggleExpand(p.id)}
                  onEdit={() => { setSelectedProject(p); setShowEdit(true); }}
                  onDelete={() => { setSelectedProject(p); setShowDelete(true); }}
                />
              ))
            )
          )}
        </div>
      )}

      {/* MODALS */}
      {showDelete && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100]">
          <div className="bg-[#1f1147] border border-white/10 p-8 rounded-[32px] w-[400px] text-center shadow-2xl animate-in zoom-in duration-300">
            <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <TrashIcon className="w-10 h-10 text-red-500" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Delete Global Project?</h2>
            <p className="text-white/50 mb-8">This action is permanent and will remove all associated services and packs for all users.</p>
            <div className="flex gap-4">
              <button onClick={() => setShowDelete(false)} className="flex-1 py-4 bg-white/5 rounded-2xl font-bold hover:bg-white/10 transition-colors">Cancel</button>
              <button onClick={handleDelete} className="flex-1 py-4 bg-red-600 rounded-2xl font-bold hover:bg-red-700 transition-colors shadow-lg shadow-red-600/20">Delete</button>
            </div>
          </div>
        </div>
      )}

      {showEdit && (
        <EditProjectModal
          project={selectedProject}
          onClose={() => setShowEdit(false)}
          onSuccess={() => { setShowEdit(false); fetchProjects(); }}
        />
      )}
    </div>
  );
}

function ProjectCard({ project, isExpanded, onToggle, onEdit, onDelete }) {

  const navigate = useNavigate();
  return (
    <div className={`bg-white/5 backdrop-blur-xl border border-white/10 rounded-[32px] overflow-hidden transition-all duration-500 ${isExpanded ? 'ring-2 ring-purple-500/50 shadow-2xl' : 'hover:bg-white/10'}`}>
      {/* <div className="p-6 md:p-8 flex flex-wrap items-center gap-6 cursor-pointer" onClick={onToggle}>
        <div className="w-12 h-12 rounded-2xl bg-indigo-600/20 border border-indigo-500/30 flex items-center justify-center text-indigo-400 shrink-0">
          <GlobeAltIcon className="w-6 h-6" />
        </div>
        
        <div className="flex-1 min-w-[200px]">
      
        <div>
    <p className="text-[10px] text-white/30 uppercase tracking-widest">
      Client
    </p>
    <h3 className="text-lg font-bold text-white">
      {project.client}
    </h3>
  </div>

        </div>

        <div className="  flex flex-row ">
  
      <div className="hidden lg:flex flex-col gap-1 items-start min-w-[150px]">
          <span className="text-[10px] uppercase tracking-widest text-white/30 font-bold">Country</span>
 

<div className="flex items-center gap-2 text-sm text-white/60">
            <ServerStackIcon className="w-4 h-4" />
            <span>{project.country}</span>
          </div>
  </div>


  
          <div className="hidden lg:flex flex-col gap-1 items-start min-w-[150px]">
          <span className="text-[10px] uppercase tracking-widest text-white/30 font-bold">Operator</span>
 

<div className="flex items-center gap-2 text-sm text-white/60">
            <ServerStackIcon className="w-4 h-4" />
            <span>{project.operator}</span>
          </div>
  </div>
  </div>

        <div className="hidden lg:flex flex-col gap-1 items-start min-w-[150px]">
          <span className="text-[10px] uppercase tracking-widest text-white/30 font-bold">Infrastructure</span>
          <div className="flex items-center gap-2 text-sm text-white/60">
            <ServerStackIcon className="w-4 h-4" />
            <span>{project.server}</span>
          </div>
        </div>

        <div className="flex -space-x-2 shrink-0">
          {project.services?.map((_, i) => (
            <div key={i} className="w-8 h-8 rounded-full border-2 border-[#12092b] bg-purple-600 flex items-center justify-center text-[10px] font-bold">
              S{i+1}
            </div>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <div className="text-xs text-white/40">
  Created By: <span className="text-white">{project.created_by_name}</span>
</div>
          
          <div className="flex gap-2">
            <button onClick={(e) => { e.stopPropagation(); onEdit(); }} className="p-3 bg-white/5 border border-white/10 rounded-xl hover:bg-purple-600/20 hover:border-purple-500/30 hover:text-purple-400 transition-all">
              <PencilSquareIcon className="w-5 h-5" />
            </button>
            <button onClick={(e) => { e.stopPropagation(); onDelete(); }} className="p-3 bg-white/5 border border-white/10 rounded-xl hover:bg-red-600/10 hover:border-red-500/30 hover:text-red-400 transition-all">
              <TrashIcon className="w-5 h-5" />
            </button>
          </div>
          <div className={`p-2 transition-transform duration-500 ${isExpanded ? 'rotate-180' : ''}`}>
             <ChevronDownIcon className="w-6 h-6 text-white/20" />
          </div>
        </div>
      </div> */}


      <div className="overflow-x-auto scrollbar-hide">
        <div className="p-6 md:p-8 flex items-center gap-4 cursor-pointer min-w-max md:min-w-0" onClick={onToggle}>

          {/* Icon */}
          <div className="w-12 h-12 rounded-2xl bg-indigo-600/20 border border-indigo-500/30 flex items-center justify-center text-indigo-400 shrink-0">
            <GlobeAltIcon className="w-6 h-6" />
          </div>

          {/* Client */}
          <div className="min-w-[180px]">
            <p className="text-xs text-white/50 uppercase tracking-widest">Client</p>
            <h3 className="text-xl font-bold text-white">{project.client}</h3>
          </div>

          {/* Country */}
          <div className="hidden lg:flex flex-col gap-1 min-w-[150px]">
            <span className="text-xs uppercase text-white/50 font-bold">Country</span>
            <div className="flex items-center gap-2 text-sm text-white/80">
              <ServerStackIcon className="w-4 h-4" />
              {project.country}
            </div>
          </div>

          {/* Operator */}
          <div className="hidden lg:flex flex-col gap-1 min-w-[150px]">
            <span className="text-xs uppercase text-white/50 font-bold">Operator</span>
            <div className="flex items-center gap-2 text-sm text-white/80">
              <ServerStackIcon className="w-4 h-4" />
              {project.operator}
            </div>
          </div>

          {/* Infrastructure */}
          <div className="hidden lg:flex flex-col gap-1 min-w-[150px]">
            <span className="text-xs uppercase text-white/50 font-bold">Server</span>
            <div className="flex items-center gap-2 text-sm text-white/80">
              <ServerStackIcon className="w-4 h-4" />
              {project.server}
            </div>
          </div>

          {/* Services */}
          <div className="flex -space-x-2 shrink-0">
            {project.services?.map((_, i) => (
              <div key={i} className="w-9 h-9 rounded-full border-2 border-[#12092b] bg-purple-600 flex items-center justify-center text-xs font-bold">
                S{i + 1}
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-4 ml-auto">
            <div className="text-sm text-white/50 ">
              Created By: <span className="text-white whitespace-nowrap">{project.created_by_name || project.created_by}</span>
            </div>

            <div className="flex gap-2">
              <button onClick={(e) => { e.stopPropagation(); onEdit(); }} className="p-3 bg-white/5 border border-white/10 rounded-xl">
                <PencilSquareIcon className="w-5 h-5" />
              </button>
              <button onClick={(e) => { e.stopPropagation(); onDelete(); }} className="p-3 bg-white/5 border border-white/10 rounded-xl">
                <TrashIcon className="w-5 h-5" />
              </button>
            </div>

            <ChevronDownIcon className={`w-6 h-6 text-white/20 transition ${isExpanded ? "rotate-180" : ""}`} />
          </div>
        </div>
      </div>

      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? 'max-h-[2000px] border-t border-white/10 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="p-8 space-y-8 bg-black/20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <InfoBlock icon={ServerStackIcon} label="Database IP" value={project.db_ip} />
            <InfoBlock icon={CpuChipIcon} label="DB Name" value={project.db_name} />
            <InfoBlock icon={InformationCircleIcon} label="Aggregator" value={project.aggregator || "N/A"} />
          </div>

          <div className="space-y-4">
            <h4 className="text-xs font-bold text-white/20 uppercase tracking-[0.2em]">Service Architecture</h4>
            <div className="grid grid-cols-1 gap-4">
              {project.services?.map((service, idx) => (
                <div key={idx} className="bg-white/5 border border-white/5 rounded-2xl p-6">
                  <div className="flex md:flex-row flex-col justify-between items-start mb-6 ">
                    <div className="flex justify-start items-start  gap-6 ">
                      {/* <h5 className="text-lg font-bold text-white">{service.service}</h5> */}
                      <h5 className="text-lg font-bold text-white">
                        Service {idx + 1}: {service.service}
                      </h5>

                      {service.flow_video && (
                        <button
                          onClick={() => {
                            // const BASE_URL = "https://uptask.visiontrek.io";
                            const BASE_URL = "";

                            const url = service.flow_video.startsWith("http")
                              ? service.flow_video
                              : `${BASE_URL}${service.flow_video}`;
                            console.log("VIDEO URL:", url); // 👈 check this


                            window.open(url, "_blank"); // ✅ correct
                          }}
                          className="px-3 py-1 bg-blue-600 rounded text-white text-xs hover:scale-105"
                        >
                          ▶ View Video
                        </button>

                      )}
                      <span className="text-purple-400 text-xs font-mono font-bold uppercase tracking-wider mt-1">{service.flow}</span>
                    </div>
                    <div className="flex  gap-2">
                      {service.packs?.map((pack, pIdx) => (
                        <span key={pIdx} className="px-3 py-1  bg-indigo-500/20 text-indigo-400 border border-indigo-500/30 rounded-lg text-xs font-bold">
                          {pack.pack_type}: {service.currency} {pack.amount}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                    <ServiceLink label="Service URL" url={service.service_url} />
                    <ServiceLink label="Callback" url={service.callback_url} />
                    <ServiceLink label="Promotion" url={service.promotion_url} />
                    <ServiceLink label="Header" url={service.header_url} />
                  </div>

                  <div className="flex flex-wrap gap-4 pt-4 border-t border-white/5">
                    <Badge label="App Path" value={service.path} />
                    {/* <Badge label="Content ID" value={service.content} /> */}
                    <Badge label="Charging" value={service.charging} />


                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoBlock({ icon: Icon, label, value }) {
  return (
    <div className="bg-white/5 p-4 rounded-2xl border border-white/5">
      <div className="flex items-center gap-2 text-white/40 mb-1 text-xs font-bold uppercase tracking-widest">
        <Icon className="w-4 h-4" />
        <span>{label}</span>
      </div>
      <p className="text-white text-lg font-medium">{value || "N/A"}</p>
    </div>
  );
}

// function ServiceLink({ label, url }) {
//   if (!url) return null;
//   return (
//     <div>
//       <span className="text-[10px] font-bold text-white/20 uppercase tracking-widest">{label}</span>
//       <a href={url} target="_blank" rel="noreferrer" className="block text-xs text-white/60 hover:text-purple-400 transition-colors truncate mt-1 underline underline-offset-4 decoration-purple-500/30 font-medium">
//         {url}
//       </a>
//     </div>
//   );
// }


function ServiceLink({ label, url }) {
  const [copied, setCopied] = useState(false);

  if (!url) return null;

  const handleCopy = async (e) => {
    e.stopPropagation(); // prevent card toggle
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div className="relative group">
      <span className="text-xs font-bold text-white/40 uppercase tracking-widest">
        {label}
      </span>

      {/* CLICKABLE URL */}
      <div
        onClick={handleCopy}
        className="block text-sm text-white/80 hover:text-purple-400 cursor-pointer truncate mt-1 underline underline-offset-4 decoration-purple-500/30 font-medium"
      >
        {url}
      </div>

      {/* TOOLTIP */}
      <div className="absolute z-50 left-0 top-full mt-2 hidden group-hover:block bg-black text-white text-xs px-3 py-2 rounded-lg shadow-lg whitespace-nowrap max-w-[300px] break-all">
        {copied ? "✅ Copied!" : url}
      </div>
    </div>
  );
}

function Badge({ label, value }) {
  return (
    <div className="flex items-center gap-2 text-[10px]">
      <span className="text-white/20 font-bold uppercase tracking-widest">{label}:</span>
      <span className="px-2 py-1 bg-white/5 rounded-md text-white/40 font-mono">{value || "-"}</span>
    </div>
  );
}

function EditProjectModal({ project, onClose, onSuccess }) {
  const [form, setForm] = useState({ ...project, flow_video: null });
  const [loading, setLoading] = useState(false);

  const handleProjectChange = (key, value) => setForm(p => ({ ...p, [key]: value }));
  const handleServiceChange = (sIndex, key, value) => {
    const s = [...form.services]; s[sIndex][key] = value; setForm(p => ({ ...p, services: s }));
  };
  const handlePackChange = (sIndex, pIndex, key, value) => {
    const s = [...form.services]; s[sIndex].packs[pIndex][key] = value; setForm(p => ({ ...p, services: s }));
  };
  const addService = () => setForm(p => ({ ...p, services: [...p.services, { service: "", packs: [{ pack_type: "", amount: "" }] }] }));
  const addPack = (sIndex) => {
    const s = [...form.services]; s[sIndex].packs.push({ pack_type: "", amount: "" }); setForm(p => ({ ...p, services: s }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     const fd = new FormData();
  //     Object.keys(form).forEach(k => { if(k !== 'services' && k !== 'flow_video') fd.append(k, form[k]); });
  //     if (form.flow_video) fd.append("video", form.flow_video);
  //     fd.append("services", JSON.stringify(form.services));
  //     const res = await updateProjectApi(project.id, fd);
  //     if (res.success) onSuccess();
  //   } catch (err) { alert(err.message); }
  //   finally { setLoading(false); }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const fd = new FormData();

      Object.keys(form).forEach(k => {
        if (k !== "services" && k !== "flow_video") {
          fd.append(k, form[k]);
        }
      });

      if (form.flow_video) {
        fd.append("video", form.flow_video);
      }

      // ✅ FIX HERE
      const cleanedServices = form.services.map(service => ({
        ...service,
        packs: service.packs
          .filter(p => p.amount !== "" && p.amount !== null) // ❗ remove empty
          .map(p => ({
            ...p,
            amount: Number(p.amount) // ✅ convert to number
          }))
      }));

      fd.append("services", JSON.stringify(cleanedServices));

      const res = await updateProjectApi(project.id, fd);

      if (res.success) onSuccess();

    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex justify-center z-[100] overflow-y-auto py-10 px-6">
      <div className="bg-[#1f1147] border border-white/10 rounded-[40px] w-full max-w-5xl h-fit p-10 shadow-2xl animate-in fade-in slide-in-from-bottom-10 duration-500">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-3xl font-bold text-white">Edit Project</h2>
          <button onClick={onClose} className="p-2 text-white/40 hover:text-white transition-colors">Close</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 bg-white/5 p-6 rounded-3xl border border-white/5">
            <Input label="Client" value={form.client} onChange={v => handleProjectChange("client", v)} />
            <Input label="Country" value={form.country} onChange={v => handleProjectChange("country", v)} />
            <Input label="Operator" value={form.operator} onChange={v => handleProjectChange("operator", v)} />
            <Input label="Aggregator" value={form.aggregator} onChange={v => handleProjectChange("aggregator", v)} />
          </div>

          <div className="space-y-6">
            {form.services?.map((s, sIdx) => (
              <div key={sIdx} className="bg-white/5 p-8 rounded-[32px] border border-white/5 relative">
                <div className="flex justify-between mb-6">
                  <h3 className="text-lg font-bold">Service {sIdx + 1}</h3>
                  <button type="button" onClick={() => addPack(sIdx)} className="text-xs text-purple-400 font-bold uppercase tracking-widest">+ Add Pack</button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                  <Input label="Name" value={s.service} onChange={v => handleServiceChange(sIdx, "service", v)} />
                  <Input label="Flow" value={s.flow} onChange={v => handleServiceChange(sIdx, "flow", v)} />
                  <Input label="Currency" value={s.currency} onChange={v => handleServiceChange(sIdx, "currency", v)} />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {s.packs?.map((p, pIdx) => (
                    <div key={pIdx} className="flex gap-2">
                      <Input compact placeholder="Type" value={p.pack_type} onChange={v => handlePackChange(sIdx, pIdx, "pack_type", v)} />
                      {/* <Input compact placeholder="Amount" value={p.amount} onChange={v => handlePackChange(sIdx, pIdx, "amount", v)} /> */}


                      <Input
                        compact
                        placeholder="Amount"
                        value={p.amount}
                        onChange={v => {
                          if (v === "" || /^[0-9.]+$/.test(v)) {
                            handlePackChange(sIdx, pIdx, "amount", v);
                          }
                        }}
                      />

                    </div>
                  ))}
                </div>
              </div>
            ))}
            <button type="button" onClick={addService} className="w-full py-4 border-2 border-dashed border-white/10 rounded-3xl text-white/40 font-bold hover:border-purple-500/50 hover:text-purple-400 transition-all">+ Add Service Module</button>
          </div>

          <button type="submit" disabled={loading} className="w-full py-4 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-2xl font-bold shadow-xl hover:scale-[1.01] transition-all">
            {loading ? "Updating Infrastructure..." : "Commit Changes"}
          </button>
        </form>
      </div>
    </div>,
    document.body
  );
}

function Input({ label, value, onChange, placeholder, compact = false }) {
  return (
    <div className="w-full">
      {label && <label className="block text-[10px] font-bold text-white/30 uppercase tracking-[0.2em] mb-2">{label}</label>}
      <input
        type="text"
        placeholder={placeholder}
        value={value || ""}
        onChange={e => onChange(e.target.value)}
        className={`w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500/50 transition-all ${compact ? 'py-2 text-xs' : ''}`}
      />
    </div>
  );
}









// import { useEffect, useState } from "react";
// import { getProjectsApi,  deleteProjectApi,updateProjectApi } from "../../app/api";
// import { useNavigate } from "react-router-dom";
// import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
// import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

// export default function ProjectsListPage() {



//   const [filters, setFilters] = useState({
//     client: "",
//     country: "",
//     service: "",
//     created_by_name: "",
//   });


//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();


//   const [selectedProject, setSelectedProject] = useState(null);
// const [showMenu, setShowMenu] = useState(null);
// const [showEdit, setShowEdit] = useState(false);
// const [showDelete, setShowDelete] = useState(false);

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   const fetchProjects = async () => {
//     try {
//       const res = await getProjectsApi();
//       if (res.success) {
//         setProjects(res.data || []);
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };





//   const handleDelete = async () => {
//     try {
//       await deleteProjectApi(selectedProject.id);
//       setShowDelete(false);
//       fetchProjects();

//       alert("✅ Project Deleted Successfully");
//     } catch (err) {
//       alert(err.message);
//     }
//   };



//   const handleFilterChange = (key, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };



//   // const filteredProjects = projects.filter((p) => {
//     const filteredProjects = (projects || []).filter((p) => {
//     return (
//       p.client?.toLowerCase().includes(filters.client.toLowerCase()) &&
//       p.country?.toLowerCase().includes(filters.country.toLowerCase()) &&
//       p.service?.toLowerCase().includes(filters.service.toLowerCase()) &&
//       (p.created_by_name || "")
//         .toLowerCase()
//         .includes(filters.created_by_name.toLowerCase())
//     );
//   });




//   const handleResetFilters = () => {
//     setFilters({
//       client: "",
//       country: "",
//       service: "",
//       created_by_name: "",
//     });
//   };




//   return (
//     <div className="min-h-screen px-6 py-6 md:mt-24 bg-gradient-to-br from-[#140c2b] via-[#1f1147] to-[#0f0825] rounded-[20px] ">

//       {/* HEADER */}
//       {/* <div className="flex justify-between items-center mb-6">
//         <div>
//           <h1 className="text-3xl font-semibold text-white">Projects</h1>
//           <p className="text-white/60 text-sm">
//             Manage all your created projects
//           </p>
//         </div>

//         <button
//           onClick={() => navigate("/projects/create")}
//           className="px-5 py-2 bg-purple-600 text-white rounded-lg shadow hover:scale-[1.03]"
//         >
//           + Create Project
//         </button>
//       </div> */}


// <div className="flex justify-between items-center mb-6">

//   <div>
//     <h1 className="text-3xl font-semibold text-white md:mt-0 mt-[-24px]">Projects</h1>
//     <p className="text-white/60 text-sm">
//       Manage all your created projects
//     </p>
//   </div>

//   {/* RIGHT BUTTONS */}
//   <div className="flex md:flex-row flex-col gap-3 ">

//     {/* ✅ NEW BUTTON */}
//     <button
//       onClick={() => navigate("/apps/list")}
//       className="px-5 py-2 bg-blue-600 text-white rounded-lg shadow hover:scale-[1.03]"
//     >
//       App Projects
//     </button>

//     <button
//       onClick={() => navigate("/projects/create")}
//       className="px-5 py-2 bg-purple-600 text-white rounded-lg shadow hover:scale-[1.03] whitespace-nowrap"
//     >
//       + Create Project
//     </button>

//   </div>

// </div>




//       {/* FILTERS */}
// <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-4 mb-6">
//   <div className="grid grid-cols-2 md:grid-cols-5 gap-4">

//     <input
//       type="text"
//       placeholder="Search by Client"
//       value={filters.client}
//       onChange={(e) => handleFilterChange("client", e.target.value)}
//       className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
//     />

//     <input
//       type="text"
//       placeholder="Search by Country"
//       value={filters.country}
//       onChange={(e) => handleFilterChange("country", e.target.value)}
//       className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
//     />

//     <input
//       type="text"
//       placeholder="Search by Service"
//       value={filters.service}
//       onChange={(e) => handleFilterChange("service", e.target.value)}
//       className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
//     />

//     <input
//       type="text"
//       placeholder="Search by Created By"
//       value={filters.created_by_name}
//       onChange={(e) => handleFilterChange("created_by_name", e.target.value)}
//       className="px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/50 outline-none"
//     />
//   {/* RESET BUTTON */}
//   <button
//       onClick={handleResetFilters}
//       className="px-2 py-2  text-sm rounded-[10px]
//       bg-gradient-to-r from-cyan-500 to-blue-500
//       text-white
//       shadow-lg
//       hover:scale-105
//       transition-all duration-300 whitespace-nowrap"
//     >
//       Reset
//     </button>
//   </div>
// </div>

//       {/* TABLE */}
//       <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl shadow-lg overflow-auto mt-10 no-scrollbar">

// {loading ? (
//   <p className="p-6 text-white/60">Loading projects...</p>
// ) : (
//   <table className="min-w-[1600px] text-sm text-left text-white">

//     {/* HEADER */}
//     <thead className="bg-white/10 text-white/80 text-xs uppercase whitespace-nowrap">
//       <tr>
//         <th className="px-4 py-3">ID</th>
//         <th className="px-4 py-3">Client</th>
//         <th className="px-4 py-3">Country</th>
//         <th className="px-4 py-3">Operator</th>
//         <th className="px-4 py-3">Aggregator</th>
//         <th className="px-4 py-3">Service</th>
//         <th className="px-4 py-3">Flow</th>
//         <th className="px-4 py-3">Pricing</th>
//         <th className="px-4 py-3">1st Day Free</th>
//         <th className="px-4 py-3">Service URL</th>
//         <th className="px-4 py-3">Promotion URL</th>
//         <th className="px-4 py-3">Server</th>
//         <th className="px-4 py-3">DB IP</th>
//         <th className="px-4 py-3">DB Name</th>
//         <th className="px-4 py-3">Path</th>
//         <th className="px-4 py-3">Content</th>
//         <th className="px-4 py-3">Content Path</th>
//         <th className="px-4 py-3">Callback URL</th>
//         <th className="px-4 py-3">Header URL</th>
//         <th className="px-4 py-3">Charging</th>
//         <th className="px-4 py-3">Flow Video</th>
//         <th className="px-4 py-3">Created By</th>
//         <th className="px-4 py-3">Created At</th>
//         <th className="px-4 py-3">Actions</th>
//       </tr>
//     </thead>

//     {/* BODY */}
//     <tbody>
//     {filteredProjects.length === 0 ? (
//         <tr>
//           <td colSpan="23" className="text-center py-6 text-white/60">
//             No projects found
//           </td>
//         </tr>
//       ) : (
//         // projects.map((p) => (
//           filteredProjects.map((p) => (
//           <tr
//             key={p.id}
//             className="border-t border-white/10 hover:bg-white/5 whitespace-nowrap"
//           >
//             <td className="px-4 py-3">{p.id}</td>
//             <td className="px-4 py-3">{p.client}</td>
//             <td className="px-4 py-3">{p.country}</td>
//             <td className="px-4 py-3">{p.operator}</td>
//             <td className="px-4 py-3">{p.aggregator || "-"}</td>
//             <td className="px-4 py-3">{p.service}</td>
//             <td className="px-4 py-3">{p.flow || "-"}</td>
//             <td className="px-4 py-3">₹{p.pricing}</td>
//             <td className="px-4 py-3">
//               {p.first_day_free ? "Yes" : "No"}
//             </td>

//             <td className="px-4 py-3 truncate max-w-[150px]">
//               {/* {p.service_url || "-"} */}
//               <CopyableCell value={p.service_url} />
//             </td>

//             <td className="px-4 py-3 truncate max-w-[150px]">
//               {/* {p.promotion_url || "-"} */}
//               <CopyableCell value={p.promotion_url} />
//             </td>

//             <td className="px-4 py-3">{p.server || "-"}</td>
//             <td className="px-4 py-3">{p.db_ip || "-"}</td>
//             <td className="px-4 py-3">{p.db_name || "-"}</td>
//             <td className="px-4 py-3">{p.path || "-"}</td>

//             <td className="px-4 py-3 truncate max-w-[200px]">
//               {p.content || "-"}
//             </td>

//             <td className="px-4 py-3">
//               {p.content_path || "-"}
//             </td>
//             {/* <td className="px-4 py-3"> */}
//             <td className="px-4 py-3 truncate max-w-[150px]">
//               {/* {p.callback_url || "-"}</td> */}
//               <CopyableCell value={p.callback_url} /></td> 
//             <td className="px-4 py-3">
//               {/* {p.header_url || "-"} */}
//               <CopyableCell value={p.header_url} />
//             </td>
//             <td className="px-4 py-3">{p.charging || "-"}</td>
//             {/* <td className="px-4 py-3">{p.flow_video || "-"}</td> */}

//             <td className="px-4 py-3">
//   {p.flow_video ? (
// <button
//   onClick={() => navigate(`/projects/video/${p.id}`)}
//   className="px-3 py-1 bg-blue-600 rounded text-white text-xs hover:scale-105"
// >
//   ▶ View Video
// </button>

//     <button
//   onClick={() => {
//     const BASE_URL = "https://uptask.visiontrek.io";

//     const url = p.flow_video.startsWith("http")
//       ? p.flow_video
//       : `${BASE_URL}${p.flow_video}`;

//     window.open(url, "_blank");
//   }}
//   className="px-3 py-1 bg-blue-600 rounded text-white text-xs hover:scale-105"
// >
//   ▶ View Video
// </button>
//   ) : (
//     "-"
//   )}
// </td>

//             <td className="px-4 py-3">
//               {p.created_by_name || "N/A"}
//             </td>

//             <td className="px-4 py-3">
//               {/* {new Date(p.created_at).toLocaleString()} */}
//               {new Date(p.created_at).toLocaleDateString()}
//             </td>


//             <td className="px-4 py-3">
//   <div className="flex items-center gap-3">

//     {/* ✏️ Edit Icon */}
//     <button
//       onClick={() => {
//         setSelectedProject(p);
//         setShowEdit(true);
//       }}
//       className="text-blue-400 hover:text-blue-300"
//     >
//       <PencilSquareIcon className="w-5 h-5" />
//     </button>

//     {/* 🗑 Delete Icon */}
//     <button
//       onClick={() => {
//         setSelectedProject(p);
//         setShowDelete(true);
//       }}
//       className="text-red-400 hover:text-red-300"
//     >
//       <TrashIcon className="w-5 h-5" />
//     </button>

//   </div>
// </td>




//           </tr>
//         ))
//       )}
//     </tbody>
//   </table>
// )}
// </div>








// {showDelete && (
//   <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">

//     <div className="bg-[#1f1147] p-6 rounded-xl w-[350px] text-center">
//       <h2 className="text-white text-lg mb-2">
//         Delete Project?
//       </h2>

//       <p className="text-white/60 text-sm mb-4">
//         Are you sure you want to delete this project?
//       </p>

//       <div className="flex justify-center gap-3">
//         <button
//           onClick={() => setShowDelete(false)}
//           className="px-4 py-2 bg-gray-500 rounded-lg text-white"
//         >
//           Cancel
//         </button>

//         <button
//           onClick={handleDelete}
//           className="px-4 py-2 bg-red-600 rounded-lg text-white"
//         >
//           Delete
//         </button>
//       </div>
//     </div>

//   </div>
// )}





// {showEdit && (
//   <EditProjectModal
//     project={selectedProject}
//     onClose={() => setShowEdit(false)}
//     onSuccess={() => {
//       setShowEdit(false);
//       fetchProjects();
//     }}
//   />
// )}


//     </div>
//   );
// }





// function EditProjectModal({ project, onClose, onSuccess }) {
//   // const [form, setForm] = useState(project);
//   const [form, setForm] = useState({ ...project });
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);

//   const handleChange = (key, value) => {
//     setForm((prev) => ({ ...prev, [key]: value }));
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     try {
//       setLoading(true);

//       const payload = {
//         ...form,
//         pricing: Number(form.pricing),
//         first_day_free: Number(form.first_day_free),
//       };

//       const res = await updateProjectApi(project.id, payload);

//       if (res.success) {
//         setSuccess(true);

//         // ✅ refresh AFTER success modal closes
//       }

//     } catch (err) {
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       {/* MAIN MODAL */}
//       <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 overflow-auto">

//         <div className="bg-[#1f1147] p-6 rounded-xl w-[800px] max-h-[90vh] overflow-y-auto">

//           <h2 className="text-white text-xl mb-4">Edit Project</h2>

//           <form onSubmit={handleUpdate} className="space-y-5">

//             {/* BASIC */}
//             <div className="grid grid-cols-2 gap-4">
//               <Input label="Client" value={form.client} onChange={(v)=>handleChange("client", v)} />
//               <Input label="Country" value={form.country} onChange={(v)=>handleChange("country", v)} />
//               <Input label="Operator" value={form.operator} onChange={(v)=>handleChange("operator", v)} />
//               <Input label="Aggregator" value={form.aggregator} onChange={(v)=>handleChange("aggregator", v)} />
//               <Input label="Service" value={form.service} onChange={(v)=>handleChange("service", v)} />
//               <Input label="Flow" value={form.flow} onChange={(v)=>handleChange("flow", v)} />
//               <Input label="Pricing" value={form.pricing} onChange={(v)=>handleChange("pricing", v)} />

//               <Select
//                 label="1st Day Free"
//                 value={form.first_day_free}
//                 onChange={(v)=>handleChange("first_day_free", v)}
//                 options={[
//                   { label: "No", value: 0 },
//                   { label: "Yes", value: 1 },
//                 ]}
//               />
//             </div>

//             {/* URLS */}
//             <div className="grid grid-cols-2 gap-4">
//               <Input label="Service URL" value={form.service_url} onChange={(v)=>handleChange("service_url", v)} />
//               <Input label="Promotion URL" value={form.promotion_url} onChange={(v)=>handleChange("promotion_url", v)} />
//               <Input label="Callback URL" value={form.callback_url} onChange={(v)=>handleChange("callback_url", v)} />
//               <Input label="Header URL" value={form.header_url} onChange={(v)=>handleChange("header_url", v)} />
//             </div>

//             {/* SERVER */}
//             <div className="grid grid-cols-2 gap-4">
//               <Input label="Server" value={form.server} onChange={(v)=>handleChange("server", v)} />
//               <Input label="DB IP" value={form.db_ip} onChange={(v)=>handleChange("db_ip", v)} />
//               <Input label="DB Name" value={form.db_name} onChange={(v)=>handleChange("db_name", v)} />
//               <Input label="Path" value={form.path} onChange={(v)=>handleChange("path", v)} />
//             </div>

//             {/* CONTENT */}
//             <Textarea label="Content" value={form.content} onChange={(v)=>handleChange("content", v)} />

//             <div className="grid grid-cols-2 gap-4">
//               <Input label="Content Path" value={form.content_path} onChange={(v)=>handleChange("content_path", v)} />
//               <Input label="Charging" value={form.charging} onChange={(v)=>handleChange("charging", v)} />
//               <Input label="Flow Video" value={form.flow_video} onChange={(v)=>handleChange("flow_video", v)} />
//             </div>

//             {/* BUTTONS */}
//             <div className="flex justify-end gap-3">
//               <button onClick={onClose} type="button" className="px-4 py-2 bg-gray-500 rounded">
//                 Cancel
//               </button>

//               <button type="submit" className="px-4 py-2 bg-purple-600 text-white rounded">
//                 {loading ? "Updating..." : "Update"}
//               </button>
//             </div>

//           </form>
//         </div>
//       </div>

//       {/* SUCCESS MODAL */}
//       {success && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
//           <div className="bg-[#1f1147] p-6 rounded-xl text-center w-[300px]">

//             <h2 className="text-white text-lg mb-2">
//               ✅ Updated Successfully
//             </h2>

//             <button
//               // onClick={() => {
//               //   setSuccess(false);
//               //   onClose(); // close edit modal


//               onClick={() => {
//                 setSuccess(false);
//                 onClose();      // close modal
//                 onSuccess();    // ✅ NOW refresh table
//               }}

//               className="px-4 py-2 bg-purple-600 text-white rounded"
//             >
//               OK
//             </button>

//           </div>
//         </div>
//       )}
//     </>
//   );
// }


// // 👇 paste BELOW EditProjectModal

// function Input({ label, value, onChange, error, type = "text" }) {
//   return (
//     <div>
//       <label className="text-sm text-white/60">{label}</label>

//       <input
//         type={type}
//         value={value || ""}
//         onChange={(e) => onChange(e.target.value)}
//         className={`
//           w-full mt-1 px-4 py-3 rounded-xl
//           bg-white/5 border
//           ${error ? "border-red-500" : "border-white/10"}
//           text-white
//         `}
//       />

//       {error && (
//         <p className="text-red-400 text-xs mt-1">{error}</p>
//       )}
//     </div>
//   );
// }

// function Textarea({ label, value, onChange }) {
//   return (
//     <div className="col-span-2">
//       <label className="text-sm text-white/60">{label}</label>
//       <textarea
//         rows={4}
//         value={value || ""}
//         onChange={(e) => onChange(e.target.value)}
//         className="
//           w-full mt-1 px-4 py-3 rounded-xl
//           bg-white/5 border border-white/10
//           text-white
//         "
//       />
//     </div>
//   );
// }

// function Select({ label, value, onChange, options }) {
//   return (
//     <div>
//       <label className="text-sm text-white/60">{label}</label>
//       <select
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         className="
//           w-full mt-1 px-4 py-3 rounded-xl
//           bg-white/5 border border-white/10
//           text-white
//         "
//       >
//         {options.map((o) => (
//           <option key={o.value} value={o.value} className="text-black">
//             {o.label}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// }



// function CopyableCell({ value, maxWidth = "150px" }) {
//   const [copied, setCopied] = useState(false);

//   if (!value) return "-";

//   const handleCopy = () => {
//     navigator.clipboard.writeText(value);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1000);
//   };

//   return (
//     <div className="relative group cursor-pointer">

//       {/* TEXT */}
//       <div
//         onClick={handleCopy}
//         className="truncate"
//         style={{ maxWidth }}
//       >
//         {value}
//       </div>

//       {/* TOOLTIP */}
//       <div className="
//         fixed
//         hidden group-hover:block
//         bg-black text-white text-xs px-2 py-1 rounded
//         z-[9999] mt-[-10px]
//         whitespace-pre-wrap
//         max-w-[400px]
//       "
//       style={{
//         top: "auto",
//       }}
//       >
//         {value}
//         {copied && <div className="text-green-400">Copied!</div>}

function DemoProjectCard({ project }) {
  return (
    <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-[32px] p-6 hover:bg-white/10 transition-all">
      <div className="flex flex-wrap items-center gap-6">
        <div className="w-12 h-12 rounded-2xl bg-orange-600/20 border border-orange-500/30 flex items-center justify-center text-orange-400 shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 0 0 2.25-2.25V6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v10.5a2.25 2.25 0 0 0 2.25 2.25Zm.75-12h9v9h-9v-9Z" />
          </svg>
        </div>
        <div className="flex-1 min-w-[200px]">
          <p className="text-xs text-white/50 uppercase tracking-widest">Demo Project</p>
          <h3 className="text-xl font-bold text-white">{project.project_name}</h3>
        </div>
        <div className="flex flex-col gap-1 min-w-[150px]">
          <span className="text-xs uppercase text-white/50 font-bold">Server</span>
          <div className="flex items-center gap-2 text-sm text-white/80">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 0 1-3-3V3.75a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v7.5a3 3 0 0 1-3 3m-13.5 0a3 3 0 0 0-3 3v3.75a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3v-3.75a3 3 0 0 0-3-3m-13.5 0h13.5m-13.5 0h13.5" />
            </svg>
            {project.server}:{project.backend_port}
          </div>
        </div>
        <div className="flex flex-col gap-1 min-w-[200px]">
          <span className="text-xs uppercase text-white/50 font-bold">URL</span>
          <a href={project.url} target="_blank" rel="noreferrer" className="text-sm text-blue-400 hover:underline truncate">
            {project.url}
          </a>
        </div>
        <div className="flex flex-col gap-1 flex-1">
          <span className="text-xs uppercase text-white/50 font-bold">Path</span>
          <p className="text-sm text-white/80 font-mono bg-black/20 px-2 py-1 rounded-md">{project.path}</p>
        </div>
      </div>
      {project.description && (
        <div className="mt-4 pt-4 border-t border-white/5 text-sm text-white/60">
          {project.description}
        </div>
      )}
    </div>
  );
}
